module.exports = __webpack_public_path__ + "img/pRuku.b05787b3.png";